import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc,
  updateDoc,
  serverTimestamp,
  addDoc,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";

function ReviewDashboard() {
  const [requests, setRequests] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [claims, setClaims] = useState([]);
  const [evidences, setEvidences] = useState({});
  const [selectedRequestId, setSelectedRequestId] = useState(null);

  useEffect(() => {
    const loadRequests = async () => {
      const q = query(
        collection(db, "verificationRequests"),
        where("status", "==", "pending")
      );
      const snap = await getDocs(q);

      const data = [];
      for (const docSnap of snap.docs) {
        const req = docSnap.data();
        const userSnap = await getDoc(doc(db, "users", req.userId));
        if (userSnap.exists()) {
          data.push({
            requestId: docSnap.id,
            userId: req.userId,
            submittedAt: req.submittedAt,
            user: userSnap.data(),
          });
        }
      }

      setRequests(data);
    };

    loadRequests();
  }, []);

  const loadUserDetails = async (userId, requestId) => {
    setSelectedUser(userId);
    setSelectedRequestId(requestId);

    const claimsSnap = await getDocs(
      query(collection(db, "claims"), where("userId", "==", userId))
    );

    const claimsData = claimsSnap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    setClaims(claimsData);

    const evSnap = await getDocs(
      query(collection(db, "evidences"), where("userId", "==", userId))
    );

    const grouped = {};
    evSnap.docs.forEach((d) => {
      const data = d.data();
      if (!grouped[data.claimId]) grouped[data.claimId] = [];
      grouped[data.claimId].push({ id: d.id, ...data });
    });

    setEvidences(grouped);
  };

  const reviewEvidence = async (evidenceId, status) => {
    await updateDoc(doc(db, "evidences", evidenceId), {
      review: {
        status,
        reviewedAt: serverTimestamp(),
      },
    });
    alert("Evidence updated");
  };

  const approveFounder = async (userId) => {
    // 1️⃣ Mark founder as verified
    await updateDoc(doc(db, "users", userId), {
      verification: {
        status: "verified",
        verifiedAt: serverTimestamp(),
        lastReviewedAt: serverTimestamp(),
      },
    });

    // 2️⃣ Close verification request
    if (selectedRequestId) {
      await updateDoc(doc(db, "verificationRequests", selectedRequestId), {
        status: "approved",
        reviewedAt: serverTimestamp(),
      });
    }

    // 3️⃣ Dashboard notification (Step 18.4.4)
    await addDoc(collection(db, "notifications"), {
      userId,
      type: "verification_result",
      message: "Your profile has been verified by Prufyy.",
      createdAt: serverTimestamp(),
      read: false,
    });

    alert("Founder verified and notified");

    // Remove from pending list in UI
    setRequests((prev) => prev.filter((r) => r.userId !== userId));
    setSelectedUser(null);
    setClaims([]);
    setEvidences({});
  };

  return (
    <div style={{ padding: 32 }}>
      <h1>Verification Requests</h1>

      <div style={{ display: "flex", gap: 32 }}>
        {/* Left panel */}
        <div style={{ width: "300px" }}>
          {requests.map((r) => (
            <div
              key={r.requestId}
              style={{
                padding: 12,
                border: "1px solid #e5e7eb",
                marginBottom: 8,
                cursor: "pointer",
              }}
              onClick={() => loadUserDetails(r.userId, r.requestId)}
            >
              <strong>{r.user.startupName}</strong>
              <p>{r.user.fullName}</p>
            </div>
          ))}
        </div>

        {/* Right panel */}
        <div style={{ flex: 1 }}>
          {claims.map((claim) => (
            <div
              key={claim.id}
              style={{
                marginBottom: 20,
                padding: 16,
                border: "1px solid #e5e7eb",
              }}
            >
              <p>
                <strong>{claim.text}</strong>
              </p>
              <p>Risk: {claim.riskLevel}</p>

              {(evidences[claim.id] || []).map((ev) => (
                <div key={ev.id} style={{ marginLeft: 16 }}>
                  <a
                    href={ev.type === "link" ? ev.url : ev.fileUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {ev.label}
                  </a>

                  <div>
                    <button onClick={() => reviewEvidence(ev.id, "approved")}>
                      Approve
                    </button>
                    <button
                      onClick={() =>
                        reviewEvidence(ev.id, "needs_clarification")
                      }
                    >
                      Needs clarification
                    </button>
                    <button onClick={() => reviewEvidence(ev.id, "rejected")}>
                      Reject
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ))}

          {selectedUser && (
            <button onClick={() => approveFounder(selectedUser)}>
              Approve Founder (Blue Tick)
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReviewDashboard;
